import adminGuard from '@/guards/adminGuard';
import authGuard from '@/guards/authGuard';
import orderGuard from '@/guards/orderGuard';
import MainView from '@/views/StartChooseLocationView.vue';
import { createRouter, createWebHistory } from 'vue-router';

import { RouteNames } from './routeNames';

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/',
            name: RouteNames.Index,
            component: MainView,
        },
        {
            path: `/${RouteNames.ToProcess}/:orderId?`,
            name: RouteNames.ToProcess,
            beforeEnter: orderGuard(),
            component: () => import('@/views/OrdersToProcessView.vue'),
        },
        {
            path: `/${RouteNames.Processed}`,
            name: RouteNames.Processed,
            component: () => import('@/views/OrdersProcessedView.vue'),
        },
        {
            path: `/${RouteNames.CreditNote}`,
            name: RouteNames.CreditNote,
            component: () => import('@/views/CreditNoteTransferredView.vue'),
        },
        {
            path: `/${RouteNames.SpecialCases}`,
            name: RouteNames.SpecialCases,
            component: () => import('@/views/SettingsSpecialCasesView.vue'),
        },
        {
            path: `/${RouteNames.Administrator}`,
            name: RouteNames.Administrator,
            beforeEnter: adminGuard(),
            component: () => import('@/views/AdministratorView.vue'),
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
        },
    ],
});

router.beforeEach(authGuard());

export default router;
